import create from 'zustand';
import { RenewalStore } from './types';

export const useRenewalStore = create<RenewalStore>((set) => ({
  isAuthenticated: false,
  setAuthenticated: (value: boolean) => set({ isAuthenticated: value })
}));
